import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation, withTranslation } from "react-i18next";
import { showSuccessNotification } from "store/notifications/actions";
import {  AvForm } from "availity-reactstrap-validation";
import AvFieldSelect from "components/Common/AvFieldSelect";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import useModal from "hooks/useModal";
import { downloadReport } from "apis/reports";

function DownloadFileType({ selectedValues }) {
  const [show, toggle] = useModal();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fileTypes = [
    "csv", "pdf", "xlsx"
  ];

  return (
    <React.Fragment >
      <div>
        <Button
          color="primary"
          size="sm"
          disabled={!selectedValues.reportType}
          onClick={toggle}
        >
          {t("Download Report")}
        </Button>
      </div>
      <Modal isOpen={show} toggle={toggle} centered={true}>
        <ModalHeader toggle={toggle}>
          {t("Download Report")}
        </ModalHeader>
        <ModalBody >
          <AvForm onValidSubmit={async (e, v) => {
            setLoading(true);
            const tzOffset = -new Date().getTimezoneOffset();
            downloadReport({
              ...selectedValues,
              // Explicitly carry the login filter into the download payload so
              // the exported file respects the same login scoping as the UI.
              login: selectedValues?.login ?? "",
              fileType: v.fileType,
              tzOffset
            }).then(async (blob) => {
              if (!blob || !(blob instanceof Blob)) {
                console.error("Download failed: response is not a Blob", blob);
                setLoading(false);
                return;
              }
              // (ADR-0010)
              if (blob.type && blob.type.includes("json")) {
                let message = t("The report will be emailed to you shortly.");
                try {
                  const parsed = JSON.parse(await blob.text());
                  if (parsed && parsed.message) message = parsed.message;
                } catch (e) {
                  message = t("The report will be emailed to you shortly.if you do not receive it, please contact support.");
                }
                dispatch(showSuccessNotification(message));
                setLoading(false);
                toggle();
                return;
              }
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute(
                "download",
                `${selectedValues.reportType}.${v.fileType}`
              );
              document.body.appendChild(link);
              link.click();
              setLoading(false);
            }).catch((err) => {
              console.error("Download error:", err);
              setLoading(false);
            });
          }} >
            <AvFieldSelect
              name="fileType"
              label={t("File Type")}
              options={fileTypes.length > 0
                ? fileTypes.map((type) => {
                  return {
                    value: type,
                    label: type.toUpperCase()
                  };
                }) : ""
              }
              required
            />
            <ModalFooter className="d-flex justify-content-center pb-0">
              <Button type="submit" color="primary" 
                disabled={loading}>
                {loading ? <i className="fa fa-spinner fa-spin" /> : t("Download")}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment >
  );
}

export default withTranslation()(DownloadFileType);
